$(window).ready(function () {
    if (window.innerWidth < 768){
        var el = $("#navMain");
        el.addClass("collapse");
    }
});